import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import {
  TechInsightsClient,
  techInsightsApiRef,
} from '@backstage-community/plugin-tech-insights-react';
import { regaskBooleanCheckResultRenderer } from './RegaskCheckResultRenderer';

/**
 * Override of the stock tech-insights API extension (`api:tech-insights`). The
 * plugin builds its client with no custom renderers, so boolean scorecard
 * checks fall back to the default json-rules-engine renderer that paints a
 * passing check with the brand color (blue). We rebuild the same client but
 * pass our success/error-tinted renderer so the catalog Scorecards card uses
 * the foundation status colors. Attaching it to pluginId `tech-insights` with
 * the same generated extension id overrides the stock one (the plugin is
 * auto-discovered via app.packages: all — see app-config.yaml).
 */
const techInsightsApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: techInsightsApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new TechInsightsClient({
          discoveryApi,
          identityApi,
          renderers: [regaskBooleanCheckResultRenderer],
        }),
    }),
});

export const techInsightsModule = createFrontendModule({
  pluginId: 'tech-insights',
  extensions: [techInsightsApi],
});
